import styled from 'styled-components';
import { Typography, TextField, Button } from '@mui/material';
import ArrowCircleRight from '@mui/icons-material/ArrowCircleRightOutlined';

// Common Container Styles
//
// The card sizes to its content. It used to be pinned to `height: 654px` on
// desktop, which left a gap under short forms (the loading and error states)
// and clipped long ones, so the spacing read differently on every identity
// screen. `min-height` keeps the pages a consistent size without capping them.
export const Container = styled.div`
  width: 100%;
  max-width: 800px;
  min-width: 300px;
  height: auto;
  background-color: white;
  display: flex;
  flex-direction: column;
  padding: 24px;
  border-radius: 12px;
  border: 1px solid #ededed;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.06);
  gap: 16px;
  direction: rtl;

  @media (min-width: 768px) {
    min-width: 800px;
    min-height: 654px;
    padding: 32px;
  }
`;

export const ButtonContract = styled(Button)`
  && {
    width: 172px;
    height: 36px;
    margin-bottom: 2px;
    background-color: #ffffff;
    color: #35373c;
    font-size: 11px;
    font-family: 'IRANYekanXFaNum';
    font-weight: 500;
    line-height: 16px;
    padding: 8px;
    padding-right: 0px;
    gap: 4px;
    text-transform: none;
    text-align: right;
    box-shadow: none;
    border: 1px solid #ededed;

    &:hover {
      background-color: #ededed;
    }
  }
`;

export const ContractBox = styled.div`
  width: 100%;
  max-width: 760px;
  min-height: 412px;
  background-color: #f9f9f9;
  border: 1px solid #ededed;
  border-radius: 8px;
  padding: 16px;
  overflow-y: auto;

  @media (max-width: 768px) {
    max-width: 350px;
    min-height: 960px;
  }
`;
export const ContractText = styled.div`
  font-family: 'IRANYekanXFaNum';
  font-size: 14px;
  color: #35373c;
  line-height: 1.5;
  text-align: right;
  direction: rtl;
  user-select: none;
`;
export const FormContract = styled.form`
  display: flex;
  flex-direction: column;
  text-align: right;
  @media (max-width: 768px) {
    /* For mobile view */
    
    max-width: 350px;

  }

`;


export const StyledButton = styled(Button)`
  && {
    width: 142px;
    height: 36px;
    background-color: #ffffff;
    color: #35373c;
    font-size: 12px;
    font-family: 'IRANYekanXFaNum';
    font-weight: 500;
    line-height: 16px;
    padding: 0;
    text-transform: none;
    box-shadow: none;
    border: 1px solid #ededed;

    &:hover {
      background-color: #ededed;
    }
  }
`;

export const Icon = styled(ArrowCircleRight)`
  color: gray;
  width: 22px;
  height: 22px;
  margin-left: 10px;
`;

export const Title = styled(Typography)`
  && {
    font-family: 'IRANYekanXFaNum';
    font-weight: 500;
    color: #35373c;
    text-align: right;
    font-size: 14px;
    line-height: 20px;
  }
`;

export const Description = styled(Typography)`
  && {
    font-family: 'IRANYekanXFaNum';
    font-weight: 900;
    color: #25282e;
    text-align: right;
    font-size: 20px;
    line-height: 26px;
  }
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 16px;
  row-gap: 16px;
  width: 100%;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

// No padding here — GridContainer already sets the gutters, and the extra 4px
// made the two columns sit unevenly against the card's edge.
export const FieldContainer = styled.div`
  text-align: right;
  width: 100%;
`;

export const Label = styled(Typography)`
  && {
    font-family: 'IRANYekanXFaNum';
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 8px;
  }
`;

export const StyledTextField = styled(TextField)`
  && {
    width: 100%;
    min-width: 310px;

    @media (min-width: 768px) {
      max-width: 372px;
    }

    .MuiOutlinedInput-root {
      border-radius: 8px;

      fieldset {
        border-color: #ededed;
      }

      &:hover fieldset {
        border-color: #cfcfcf;
      }

      &.Mui-focused fieldset {
        border-color: #afafaf;
      }

      input {
        padding: 12px 14px;
      }
    }

    // Style for error messages
    .MuiFormHelperText-root {
      font-size: 12px;
      color: red;
      text-align: right;
      margin-top: 0px;
    }
  }
`;

export const SubmitButtonBox = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
`;

export const SubmitButton = styled(Button)`
  && {
    width: 175px;
    height: 40px;
    background-color: #1e88e5;
    color: #ffffff;
    font-size: 12px;
    font-family: 'IRANYekanXFaNum';
    font-weight: 700;
    padding: 12px 16px;
    border-radius: 4px;
    text-transform: none;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.08);
    direction: ltr;

    &:hover {
      background-color: #1565c0;
    }
  }
`;

export const UploadContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const ErrorText = styled(Typography)`
  && {
    font-family: 'IRANYekanXFaNum';
    font-size: 10px;
    font-weight: 500;
    margin-bottom: 0px;
    color: red;
    position: absolute;
    text-align: right;
  }
`;